/* Autogenerated file - do not modify */ 
import Enum from "./enum";

export default class BTIncomingAttackClassification extends Enum {
    static REAL =  new BTIncomingAttackClassification("REAL", "real")
    static FAKE =  new BTIncomingAttackClassification("FAKE", "fake")
    
    static cases() {
        return enumCases;
    }
}
const enumCases = [BTIncomingAttackClassification.REAL, BTIncomingAttackClassification.FAKE];
